import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const locationAPI = {
    create: async (locationData) => {
        try {
            const { data } = await api.post('/api/locations/create/', locationData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create location error:');
        }
    },
    getAll: async (warehouse_id, page, pageSize, searchTerm, showDeactivated, includeItemCount) => {
        try {
            const { data } = await api.get(`/api/warehouses/${warehouse_id}/locations`, {
                params: { page, pageSize, searchTerm, showDeactivated, includeItemCount }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all locations error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/locations/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get location by id error:');
        }
    },
    update: async (id, locationData) => {
        try {
            const { data } = await api.put(`/api/locations/update/${id}/`, locationData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update location error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/locations/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete location error:');
        }
    }
};